module.exports=atom